// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__Kp5a+","aboutImg":"About_aboutImg__wuOBx","aboutText":"About_aboutText__gLNPP","aboutBtn":"About_aboutBtn__5pd8l"};